/* import __COLOCATED_TEMPLATE__ from './seller-profile-equipment-list.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

/**
 * +-----+--------------------------+
 * | id  | name                     |
 * +-----+--------------------------+
 * | 186 | 2K video camera          |
 * | 190 | 4K video camera          |
 * | 194 | Full HD video camera     |
 * | 198 | Multiple cameras         |
 * | 202 | DSLR or equivalent       |
 * | 206 | External recorder        |
 * | 210 | Lighting kit             |
 * | 214 | Wireless lavalier mic    |
 * | 218 | Shotgun mic              |
 * | 222 | Stabilizer               |
 * | 226 | Shoulder rig             |
 * | 230 | Sliders                  |
 * | 234 | Dolly                    |
 * | 238 | GoPro or equivalent      |
 * | 242 | Live streaming equipment |
 * | 246 | Satellite phone          |
 * | 250 | Drone                    |
 * +-----+--------------------------+
 */

const EQUIPMENT_VIDEO_KEYS = [186, 190, 194, 198, 202, 238, 250];
const EQUIPMENT_AUDIO_KEYS = [206, 214, 218];

export default class SellerProfileEquipmentList extends Component {
  @tracked videoEquipment;
  @tracked audioEquipment;
  @tracked miscEquipment;

  get className() {
    return 'SH-c-seller-profile-freelancer-profile__equipment-list';
  }

  get videoMap() {
    return EQUIPMENT_VIDEO_KEYS.reduce((accum, f) => {
      accum[f] = true;
      return accum;
    }, {});
  }

  get audioMap() {
    return EQUIPMENT_AUDIO_KEYS.reduce((accum, f) => {
      accum[f] = true;
      return accum;
    }, {});
  }

  get hasEquipment() {
    const equipment = this.filterEquipment(this.args.user.profile.equipment);
    return equipment.videoEquipment || equipment.audioEquipment || equipment.miscEquipment;
  }

  filterEquipment(equipment) {
    const videoEquipment = [];
    const audioEquipment = [];
    const miscEquipment = [];
  
    equipment.forEach((model) => {
      const { id, name } = model;
  
      if (id in this.videoMap) {
        videoEquipment.push(name);
      } else if (id in this.audioMap) {
        audioEquipment.push(name);
      } else {
        miscEquipment.push(name);
      }
    });

    this.videoEquipment = videoEquipment;
    this.audioEquipment = audioEquipment;
    this.miscEquipment = miscEquipment;
  
    return { videoEquipment, audioEquipment, miscEquipment };
  };
}
